import { memo, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { IReadOnlyLinkListProps } from './models'

import styles from './ReadOnlyLinkList.module.scss'

export const ReadOnlyLinkList = memo<IReadOnlyLinkListProps>(({ label, links }) => {
  const renderContent = useCallback(
    () =>
      links.map((link) => (
        <div key={link.id} className={styles.link}>
          <div className={styles.linkValue}>{link.value}</div>
          <div className={styles.isPrivate}>Private: {link.private ? 'Yes' : 'No'}</div>
        </div>
      )),
    [links]
  )

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        <Translation text={label} />
      </div>
      {links.length > 0 ? renderContent() : '-'}
    </div>
  )
})
